
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"></path><path d="M9.04546 10.7727C9.04546 11.1743 8.71985 11.5 8.31818 11.5C7.91652 11.5 7.59091 11.1743 7.59091 10.7727C7.59091 10.371 7.91652 10.0454 8.31818 10.0454C8.71985 10.0454 9.04546 10.371 9.04546 10.7727Z"></path><path d="M13.6364 10.3636H16.0909"></path><path d="M8.72726 14.4546H15.2727"></path><path d="M13.6364 15.4546V16.091C13.6364 16.5249 13.464 16.9412 13.1571 17.248C12.8502 17.5549 12.434 17.7273 12 17.7273C11.566 17.7273 11.1498 17.5549 10.8429 17.248C10.536 16.9412 10.3636 16.5249 10.3636 16.091V15.4546"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiIconlibrary",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
